import { AddFile, Loader } from '@assets/icons'
import { ICompleteFile } from '@interfaces/realEstateFiles/iCompleteFile'
import { downloadPdf } from '@utils/index'
import { readerFile } from '@utils/pdf/download'
import React from 'react'
import { FieldValues, Path, UseFormRegister } from 'react-hook-form'
import { FiDownload } from 'react-icons/fi'
import { RiDeleteBin5Fill } from 'react-icons/ri'
import { Params } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ButtonAction } from '..'

interface IinputFile<T extends FieldValues> {
    acceptFiles: string
    isLoadingFile?: boolean
    name?: Path<T>
    register?: UseFormRegister<T>
    multiple?: boolean
    fileDefault?: ICompleteFile | null
    style?: object
    params?: Readonly<Params<string>>
    onChange: (value: File | null) => void
    fileFormToDelete?: (value: number) => void
}

export default function InputFile<T extends FieldValues>(props: IinputFile<T>): React.ReactElement {
    const [file, setFile] = React.useState<File | string | null>(null)
    const handleFile = React.useRef<HTMLInputElement | null>(null)
    const handleClick = React.useCallback(() => {
        handleFile.current?.click()
    }, [])

    const handleDelete = React.useCallback(() => {
        if (handleFile.current) handleFile.current.value = ''
        props.onChange(null)
        setFile(null)
        if (props.fileDefault) {
            if (props.fileFormToDelete)
                props.fileFormToDelete(props.fileDefault?.id)
        }
    }, [])

    function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        if (e.target.files !== null) {
            const files = e.target.files
            for (let index = 0; index < files.length; index++) {
                const element = files.item(index)
                if (element) {
                    const fileAccepted = props.acceptFiles.includes(element.type)
                    if (!fileAccepted) {
                        toast('Formato de arquivo inválido', { type: 'error' })
                        continue
                    }
                    props.onChange(element)
                }
                if (!props.multiple) {
                    setFile(element)
                }
            }
        }
    }

    React.useEffect(() => {
        if (props.fileDefault) setFile(props.fileDefault.fileFromS3)
    }, [props.fileDefault])

    return (
        <>
            <input
                type='file'
                ref={handleFile}
                onChange={handleChange}
                disabled={props.isLoadingFile}
                accept={props.acceptFiles}
                style={{ display: 'none' }}
                multiple={props.multiple}
            />

            <div
                className={`input-file ${!props.multiple ? 'external-single-file' : ''}`}
                style={props.style}
            >
                {!props.multiple && file ?
                    <div className='box-single-file' style={props.style}>
                        {props.acceptFiles === 'application/pdf' && file ?
                            <object
                                data={readerFile(file)}
                                type="application/pdf"
                                width="100%"
                                height="100%"
                            />
                            : <img src={readerFile(file)} alt="Logo do empreendimento" style={props.style} />
                        }
                        <div className='cover-image' style={props.style}>
                            <ButtonAction
                                title='Deletar'
                                type='button'
                                onClick={() => {
                                    handleDelete()
                                }}
                            >
                                <RiDeleteBin5Fill className='icon-button-action' />
                            </ButtonAction>

                            {props.acceptFiles === 'application/pdf' && file &&
                                <ButtonAction
                                    title='Baixar'
                                    type='button'
                                    onClick={
                                        () => downloadPdf(file)
                                    }
                                >
                                    <FiDownload className='icon-button-action' />
                                </ButtonAction>
                            }
                        </div>
                    </div>
                    :
                    <button
                        className='button-input-file'
                        onClick={handleClick}
                        type='button'
                        title='Input de arquivos'
                    >
                        {props.isLoadingFile ?
                            <Loader style={{ width: '2rem' }} />
                            :
                            <AddFile className='icon-addfile' title='Adicionar Arquivo' />
                        }
                    </button>
                }
            </div>
        </>
    )
}
